import { makeStyles, Avatar } from '@material-ui/core';
import { NotiIcon, TimeIcon } from '../../Icon';
import Time from './time';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '19.4388rem',
    borderBottomColor: '#E4E7EB',
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
  },
  body: {
    padding: '1.75rem 0 0 1.875rem',
  },
  head: {
    display: 'flex',
    marginBottom: '0.938rem',
  },
  avatar: {
    width: '2.25rem',
    height: '2.25rem',
    backgroundColor: theme.palette.staff.yellow,
    color: theme.palette.font.white,
    marginRight: '0.75rem',
    borderRadius: '50%',
    '& $icon': {
      fontSize: '1.75rem',
    },
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.125rem',
    color: theme.palette.font.main,
    fontWeight: '600',
    letterSpacing: 0,
  },
  context: {
    width: '15.688rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    lineHeight: '1.5rem',
    color: theme.palette.font.main,
  },
  foot: {
    marginTop: '2.75rem',
    marginBottom: '1.25rem',
    display: 'flex',
  },
  timeicon: {
    color: theme.palette.font.sub,
    marginRight: '0.695rem',
  },
  footContext: {
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
  },
}));

export default function Notify(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.body}>
        <div className={classes.head}>
          <Avatar className={classes.avatar}>
            <NotiIcon className={classes.icon} />
          </Avatar>

          <div className={classes.title}>{props.title}</div>
        </div>
        <div className={classes.context}>{props.context}</div>
        <div className={classes.foot}>
          <TimeIcon className={classes.timeicon} />
          <div className={classes.footContext}>{Time(props.time)}</div>
        </div>
      </div>
    </div>
  );
}
